import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function SuccessModal() {
  const navigate = useNavigate();

  useEffect(() => {
    window.$("#successModal").modal("show");
    localStorage.removeItem("connectedCheck");
  }, []);

  const handleClose = () => {
    localStorage.removeItem("connectedCheck");
    navigate("/");
  };

  return (
    <div
      className="modal show"
      id="successModal"
      tabIndex="-1"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      aria-labelledby="successModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog custom-modal modal-dialog-centered">
        <div className="modal-content dark">
          <div className="modal-header text-center">
            <h1 className="modal-title" id="successModalLabel">
              Thank You!
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => handleClose()}
            ></button>
          </div>
          <div className="modal-body">
            <div className="text-center">
              <p className="mb--50">
                You've been whitelisted successfully!
                <br />
                We will let you know once the land sale is live.
              </p>
            </div>

            <div className="text-center">
              <a
                href="https://discord.com/invite/virtua"
                className="btn btn-primary custom-btn lg"
                target="_blank"
                rel="noreferrer"
              >
                <span className="icon">
                  <img src="assets/imgs/social/discord.svg" alt="" />
                </span>
                Join our discord
              </a>
            </div>
          </div>
          <div className="modal-footer"></div>
        </div>
      </div>
    </div>
  );
}
